/* ---------- [ AUTO COMPLETE ] */

function Autocomplete(url, idSearch) {
    var referenceVal = Slugify(document.getElementById(idSearch).value);

    var dropdownAutocompleteId = "dropdownAutocomplete_" + idSearch;

    if (referenceVal.length > 2) {

        var http = new XMLHttpRequest();
        http.onload = function () {
            var jsonData = JSON.parse(http.responseText);
            if (jsonData.length != 0) {
                if (!document.getElementById(dropdownAutocompleteId)) {
                    var details = document.createElement("div");
                    details.id = dropdownAutocompleteId;

                    var ul = document.createElement("ul")
                    ul.className = "sub-item-autocomplete"

                    details.appendChild(ul);

                    insertAfter(document.getElementById(idSearch), details)
                }
                else {
                    document.querySelector("#" + dropdownAutocompleteId + " .sub-item-autocomplete").innerHTML = "";
                }

                for (var i = 0; i < jsonData.length; i++) {
                    var li = document.createElement("li");

                    var div = document.createElement("div");
                    div.innerHTML = jsonData[i]

                    li.appendChild(div)

                    document.querySelector("#" + dropdownAutocompleteId + " ul").appendChild(li)
                }

                document.querySelector("#" + dropdownAutocompleteId + " ul").onclick = function (e) {
                    var target = e.target || e.srcElement;

                    // Remonte jusqu'au li si on clique sur un enfant
                    var li = target.closest('li');
                    if (!li) return; // clic en dehors d'un li, on ignore

                    var content = li.querySelector('a, div');
                    if (!content) return;

                    document.getElementById(idSearch).value = content.innerHTML;

                    var dropdownAutocomplete = document.getElementById(dropdownAutocompleteId);
                    dropdownAutocomplete.parentNode.removeChild(dropdownAutocomplete);
                };
            }
            else if (document.getElementById(dropdownAutocompleteId)) {
                var dropdownAutocomplete = document.getElementById(dropdownAutocompleteId);
                dropdownAutocomplete.parentNode.removeChild(dropdownAutocomplete);
            }
        }

        http.open("post", url.replace('--SEARCH--', referenceVal, true));
        http.send();
    }
    else if (document.getElementById(dropdownAutocompleteId)) {
        var dropdownAutocomplete = document.getElementById(dropdownAutocompleteId);
        dropdownAutocomplete.parentNode.removeChild(dropdownAutocomplete);
    }
}

//Fonction de formatage d'un slug
function Slugify(str) {
    str = str.replace(/^\s+|\s+$/g, '');

    str = str.toLowerCase();

    var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

    return str;
}

function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

//Masquer les résultats en cliquant hors de la dropdown
document.addEventListener("click", function (event) {
    var dropdowns = document.querySelectorAll('[id^="dropdownAutocomplete_"]');

    dropdowns.forEach(function (dropdown) {
        var idSearch = dropdown.id.replace('dropdownAutocomplete_', '');
        var input = document.getElementById(idSearch);

        if (!dropdown.contains(event.target) && event.target !== input) {
            dropdown.parentNode.removeChild(dropdown);
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('searchEngine');
    if (input) {
        input.addEventListener('keyup', function () {
            Autocomplete('/search/autocomplete/--SEARCH--', 'searchEngine');
        });
    }
});